<template>
  <div>
    <div class="list_page" id="list-center">
      <div class="c_channel">
        <a
          class="channel_item"
          v-for="item in channelList"
          :key="item.at_id"
          :href="
            item.at_name == '推荐'
              ? '/marvel-list?id=' + item.at_id
              : '/list-page?id=' + item.at_id
          "
          :class="item.at_id == currentId ? 'active' : ''"
        >
          {{ item.at_name }}
        </a>
      </div>
      <div class="v_list_content">
        <!--        <ul class="v_list_ul" v-infinite-scroll="addVideoList()">-->
        <ul class="v_list_ul">
          <li class="v_list_li" v-for="item in videoList" :key="item.id">
            <div class="v_item">
              <a
                :href="
                  '/play-page?id=' + item.id + '&classify=' + item.classify
                "
                target="_blank"
              >
                <img :src="item.img_url[0]" />
                <div class="v_detail">
                  <span class="v_timestamp">{{ item.publish_date }}</span>
                  <span class="v_duration">{{ item.video_duration }}</span>
                </div>
                <div class="v_title">
                  <h4 class="main">{{ item.title }}</h4>
                  <p class="sub" v-html="item.desc"></p>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
      <pagination :total="total" :handle-current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { getVideoList, getChannelList } from "@/api";
import Pagination from "./component/Pagination";
export default {
  name: "ListPage",
  components: { Pagination },
  data() {
    return {
      total: 0,
      channelList: [],
      videoList: [],
      currentId: "",
    };
  },
  created() {
    this.initChannelList();
    this.currentId = this.$route.query.id;
    this.addVideoList(1);
  },
  methods: {
    async addVideoList(e) {
      try {
        let { data } = await getVideoList({
          at_id: this.$route.query.id,
          page: e,
          size: 20,
        });
        this.videoList = data.list;
        this.total = Number(data.count);
      } catch (e) {
        console.log(e);
      }
    },
    async initChannelList() {
      try {
        let { data } = await getChannelList();
        this.channelList = data;
      } catch (e) {
        console.log(e);
      }
    },
    scrollTop() {
      let element = window;
      element.scrollTo(0, 0);
    },
    handleCurrentChange(e) {
      this.addVideoList(e);
      this.scrollTop();
    },
  },
};
</script>

<style lang="scss" scoped>
.list_page {
  width: 1200px;
  margin: 0 auto;

  .c_channel {
    display: flex;
    flex-wrap: wrap;
    padding: 24px 0 0;

    .channel_item {
      position: relative;
      width: 220px;
      margin-bottom: 10px;
      font-size: 22px;
      font-weight: 600;
      line-height: 30px;
      color: #353535;
      text-decoration: none;
    }

    .channel_item:hover {
      color: #1f91f4;
    }

    .active {
      color: #1f91f4;
    }

    .channel_item:nth-child(1)::before,
    .channel_item:nth-child(2)::before,
    .channel_item:nth-child(3)::before,
    .channel_item:nth-child(4)::before,
    .channel_item:nth-child(5)::before {
      //position: absolute;
      //top: 14px;
      //right: 67px;
      //width: 1px;
      //height: 42px;
      //content: "";
      //background: #979797;
      //filter: blur(1px);
      //border: 1px solid #979797;
      @include channelSize;
    }

    .channel_item:nth-child(6n + 6) {
      width: 100px;
    }
  }

  .v_list_content {
    margin-top: 40px;

    .v_list_ul {
      padding: 0;
      margin: 0;
      list-style-type: none;

      .v_list_li {
        float: left;
        margin: 40px 40px 20px 0;

        .v_item {
          width: 270px;
          height: 210px;
          a {
            color: #333;
            text-decoration: none;
          }
          img {
            width: 100%;
            height: 71%;
          }

          .v_detail {
            height: 30px;
            margin-top: -30px;

            span {
              display: inline-block;
              width: 40%;
              height: 100%;
              font-size: 14px;
              color: #fff;
            }

            span:nth-child(1) {
              margin-left: 5%;
              text-align: left;
            }

            span:nth-child(2) {
              margin-left: 10%;
              text-align: right;
            }
          }

          .v_title {
            width: 270px;
            height: 50px;

            * {
              overflow: hidden;
              -webkit-text-overflow: ellipsis;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .main {
              height: 20px;
              margin-bottom: 10px;
              font-size: 16px;
            }

            .sub {
              height: 20px;
              margin-bottom: 10px;
              font-size: 14px;
              color: #999;
              ::v-deep * {
                height: inherit;
                padding: 0;
                margin: 0;
              }
              ::v-deep p {
                @include textoverflow();
              }
              ::v-deep td {
                @include textoverflow();
              }
            }
          }
        }
      }

      .v_list_li:nth-child(4n + 4) {
        margin-right: 0;
      }
      .v_list_li:nth-child(1) {
        margin-top: 0;
      }
      .v_list_li:nth-child(2) {
        margin-top: 0;
      }
      .v_list_li:nth-child(3) {
        margin-top: 0;
      }
      .v_list_li:nth-child(4) {
        margin-top: 0;
      }
    }
  }

  .clear {
    clear: both;
  }
}
.v_more,
.v_no {
  width: 100%;
  height: 20px;
  //padding-top: 10px;
  margin-top: 30px;
  font-size: 16px;
  color: #333;
  text-align: center;
  img {
    height: 16px;
    padding-right: 3px;
  }
}
</style>
